import { accessTokenKey, idTokenKey } from "../entries";

export const setAccessToken = (accessToken) => {
  accessToken = JSON.stringify(accessToken);
  localStorage.setItem(accessTokenKey, accessToken);
};

export const removeAccessToken = () => {
  localStorage.removeItem(accessTokenKey);
};

export const resolveAccessToken = (accessToken) => {
  return JSON.parse(accessToken);
};

export const getAccessToken = () => {
  const accessToken = localStorage.getItem(accessTokenKey);
  if (accessToken) {
    return resolveAccessToken(accessToken);
  } else {
    return false;
  }
};

export const setIdToken = (idToken) => {
  idToken = JSON.stringify(idToken);
  localStorage.setItem(idTokenKey, idToken);
};

export const removeIdToken = () => {
  localStorage.removeItem(idTokenKey);
};

export const resolveIdToken = (idToken) => {
  try {
    return JSON.parse(idToken);
  } catch {
    return null;
  }
};

export const getIdToken = () => {
  const idToken = localStorage.getItem(idTokenKey);
  if (idToken) {
    return resolveIdToken(idToken);
  } else {
    return false;
  }
};
